// src/themes.js

import { createTheme } from '@mui/material/styles';

const uiSettingsLightMode = {
    typography: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: 13,
        fontWeight: 400,

        title1: {
            fontSize: 20,
            fontWeight: 600,
            marginBottom: 8
        },
        title2: {
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle1: {
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle2: {
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 8
        },
        body1: {
            fontSize: 13,
            fontWeight: 400,
            // marginBottom: 8
        },
        body2: {
            fontSize: 13,
            fontWeight: 400,
            marginBottom: 8
        },
        h1: {
            fontSize: 32,
            fontWeight: 500,
            marginBottom: 8
        },
        h2: {
            fontSize: 24,
            fontWeight: 500,
            marginBottom: 8
        },
        h3: {
            fontSize: 20,
            marginBottom: 8,
            fontWeight: 700
        },
        h4: {
            fontSize: 18,
            marginBottom: 8,
        },
        // h5: {},
        h5: {
            fontSize: 16,
            fontWeight: 500,
            marginBottom: 8
        },
        h6: {
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 8
        },

        label: {
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 4,
            display: 'inline-block'
        },
        labelSm: {
            fontSize: 12,
            fontWeight: 600,
            marginBottom: 4,
            display: 'inline-block',
            maxHeight: '18px'
        },
        link: {
            color: '#05344B',
            textDecoration: 'underline'
        },
        placeholder: {
            color: '#7F7F7F',
            opacity: 0.75,
            textTransform: 'none'
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: false,
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    fontSize: '1rem',
                    // color: '#FFF',
                    '@media screen and (max-width:900px)': {
                        padding: '4px 12px',
                    },
                    '&.Mui-disabled': {
                        background: '#E5D7EF',
                        color: '#FFF'
                    }
                }
            },
            variants: [
                {
                    props: { variant: 'light' },
                    style: {
                        textTransform: 'none',
                        border: `1px solid transparent`,
                        backgroundColor: 'rgba(255,255,255,1)',
                        '&:hover': {
                            backgroundColor: 'rgba(255,255,255,0.5)',
                        },
                        '&.Mui-disabled': {
                            backgroundColor: 'rgba(190, 190, 190, 0.2)',
                            color: '#3b3b3b'
                        }
                    },
                },
                {
                    props: { variant: 'contained' },
                    style: {
                        color: '#FFF'
                    },
                },

            ],


        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: 'true'
            }
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    color: '#b7b3b9',
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '11px',
                    marginLeft: '12px',
                    marginTop: ' 3px',
                    marginRight: '0',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '& .MuiSelect-select': {    //custom multi select
                        padding: '8px 12px',
                    },
                    '& input': {
                        padding: '8px 12px',
                        fontSize: '1rem',
                        '::placeholder': {
                            color: '#7F7F7F',
                            opacity: 0.75,
                        },
                    },
                    // '& fieldset': {
                    //     borderColor: '#E1E1E0',
                    //     borderWidth: '1px',
                    //     borderRadius: '8px'
                    // },
                    '&.Mui-disabled': {
                        background: '#F5F5F5',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled fieldset': {
                        borderWidth: '1px',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled  .MuiInputAdornment-root': {
                        display: 'none'
                    },
                    '&.Mui-disabled .MuiSelect-icon': {
                        display: 'none'
                    },
                    // '&.MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline ': {
                    //     borderColor: '#A77BCA',
                    //     borderWidth: '1px',
                    // },
                    // '&.Mui-focused fieldset': {
                    //     border: 'none',
                    //     boxShadow: '0 0 0 2.5px #E5D7EF',
                    //     borderWidth: '1px',
                    // },
                    // '&.Mui-error fieldset': {
                    //     borderColor: '#d32f2f',
                    //     borderWidth: '1px',
                    // },
                    '.MuiOutlinedInput-notchedOutline': {
                        borderRadius: '8px'
                    },
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    '&.MuiTabs-root': {
                        fontWeight: 500,
                        '& .MuiButtonBase-root': {
                            fontSize: '1rem',
                            textTransform: 'capitalize',
                            '&.Mui-selected': {
                            }
                        }
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    // boxShadow: 'none'
                    boxShadow: '0px 4px 10px 0px #E7DEEE33',
                    // borderRadius: '10px',
                    // backgroundColor: '#FFF',
                    '&.MuiPaper-outlined': {
                        borderColor: '#EFEEF0'
                    },
                    '&.MuiPopover-paper': {
                        boxShadow: '0px 4px 10px 0px #0000001F',
                        backgroundImage: 'none'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    height: 24,
                    lineHeight: 'normal'
                }
            }
        },
        MuiPickersPopper: {
            styleOverrides: {
                root: {
                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px'
                }
            }
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    // backgroundColor:'red',      
                    '& .MuiPaper-root': {
                        backgroundImage: 'none',
                    },
                    '&.MuiAutocomplete-popper .MuiPaper-root': {
                        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                        borderRadius: '4px',
                        // backgroundColor:'red'
                    },
                    '&.zIndex-1400': {
                        zIndex: 1700
                    }

                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    zIndex: 1700
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 1700
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    zIndex: 1600
                }
            }
        }

    }
};


// Default Theme [purple]

export const defaultLightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#A77BCA',  //violet
            light: '#B995D5',
            dark: '#9270AD',
            shade: '#fbf5ff',
            hover: '#E1D4EC',
            active: '#F0EDF2'
        },
        secondary: {
            main: '#110C14' //dark text
        },
        success: {
            main: '#1B6F14',
            light: '#F2FDE2',
            shade: '#009873',
            dashboard: '#02C791',
        },
        error: {
            main: '#E64744',
            light: '#FDE2E2',
            dashboard: '#EF0107'
        },
        info: {
            main: '#5FD7FF',
            light: '#F4FCFF',
            dashboard: '#4AAADF'
        },
        warning: {
            main: '#F1B417',
            light: '#FFFCF3',
            dashboard: '#F9CC50'
        },
        text: {
            primary: '#3B3B3B',    //light
            secondary: '#110C14', //dark
            disabled: '#909090',
            grey: '#9E9E9E',  //grey-text
        },
        background: {
            default: '#FCF8FF',     // applies to the body tag
            paper: '#FFF',
            tableHeader: '#F0EDF2',
            bgGrey: '#F8F8F8'
        },
        border: {
            main: 'rgba(239, 238, 240, 1)'
        },
    },
    ...uiSettingsLightMode
},
);

// Blue Theme

export const blueLightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#62B5DD',//Light blue    
            hover: '#d1eaf5',
            active: '#DCF4FF'

        },
        secondary: {
            main: '#110C14' //dark text
        },
        success: {
            main: '#1B6F14',
            light: '#F2FDE2',
            shade: '#009873',
            dashboard: '#02C791',
        },
        error: {
            main: '#E64744',
            light: '#FDE2E2',
            dashboard: '#EF0107'
        },
        info: {
            main: '#5FD7FF',
            light: '#F4FCFF',
            dashboard: '#4AAADF'
        },
        warning: {
            main: '#F1B417',
            light: '#FFFCF3',
            dashboard: '#F9CC50'
        },
        text: {
            primary: '#3B3B3B',    //light
            secondary: '#110C14', //dark
            disabled: '#909090',
            grey: '#9E9E9E',  //grey-text
        },
        background: {
            default: '#F3FBFF',     // applies to the body tag
            paper: '#FFF',
            tableHeader: '#F0EDF2',
            bgGrey: '#F8F8F8'
        },
        border: {
            main: 'rgba(239, 238, 240, 1)'
        },
    },

    ...uiSettingsLightMode,
    components: {
        ...uiSettingsLightMode?.components,
        MuiButton: {
            ...uiSettingsLightMode?.components?.MuiButton,
            styleOverrides: {
                ...uiSettingsLightMode?.components?.MuiButton?.styleOverrides,
                root: {
                    ...uiSettingsLightMode?.components?.MuiButton?.styleOverrides?.root,
                    '&.Mui-disabled': {
                        color: '#FFF',
                        backgroundColor: '#C5E6EC',
                    },
                },
            },
        },
    },
});

// Green Theme

export const greenLightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#81C44D', //Light Green  
            hover: '#cdedb3',
            active: '#DEFAC9'
        },
        secondary: {
            main: '#110C14' //dark text
        },
        success: {
            main: '#1B6F14',
            light: '#F2FDE2',
            shade: '#009873',
            dashboard: '#02C791',
        },
        error: {
            main: '#E64744',
            light: '#FDE2E2',
            dashboard: '#EF0107'
        },
        info: {
            main: '#5FD7FF',
            light: '#F4FCFF',
            dashboard: '#4AAADF'
        },
        warning: {
            main: '#F1B417',
            light: '#FFFCF3',
            dashboard: '#F9CC50'
        },
        text: {
            primary: '#3B3B3B',    //light
            secondary: '#110C14', //dark
            disabled: '#909090',
            grey: '#9E9E9E',  //grey-text
        },
        background: {
            default: '#F8FFF2',     // applies to the body tag
            paper: '#FFF',
            tableHeader: '#F0EDF2',
            bgGrey: '#F8F8F8'
        },
        border: {
            main: 'rgba(239, 238, 240, 1)'
        },
    },
    ...uiSettingsLightMode,
    components: {
        ...uiSettingsLightMode?.components,
        MuiButton: {
            ...uiSettingsLightMode?.components?.MuiButton,
            styleOverrides: {
                ...uiSettingsLightMode?.components?.MuiButton?.styleOverrides,
                root: {
                    ...uiSettingsLightMode?.components?.MuiButton?.styleOverrides?.root,
                    '&.Mui-disabled': {
                        color: '#FFF',
                        backgroundColor: '#DAEDCC',
                    },
                },
            },
        },
    },
});

// ------------------------Light Mode Ends----------------------------------



// Dark Mode Theme
const uiSettingsDarkMode = {
    typography: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: 13,
        fontWeight: 400,
        color: '#b7b3b9',

        title1: {
            fontSize: 20,
            fontWeight: 600,
            marginBottom: 8,
        },
        title2: {
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle1: {
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 8
        },
        subtitle2: {
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 8
        },
        body1: {
            fontSize: 13,
            fontWeight: 400,
            // marginBottom: 8
        },
        body2: {
            fontSize: 13,
            fontWeight: 400,
            marginBottom: 8
        },
        h1: {
            fontSize: 32,
            fontWeight: 500,
            marginBottom: 8
        },
        h2: {
            fontSize: 24,
            fontWeight: 500,
            marginBottom: 8
        },
        h3: {
            fontSize: 20,
            marginBottom: 8,
            fontWeight: 700
        },
        h4: {
            fontSize: 18,
            marginBottom: 8,
        },
        // h5: {},
        h5: {
            fontSize: 16,
            fontWeight: 500,
            marginBottom: 8
        },
        h6: {
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 8
        },

        label: {
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 4,
            display: 'inline-block'
        },
        labelSm: {
            fontSize: 12,
            fontWeight: 600,
            marginBottom: 4,
            display: 'inline-block',
            maxHeight: '18px'
        },
        link: {
            color: '#05344B',
            textDecoration: 'underline'
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: false,
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    fontSize: '1rem',
                    color: '#fff',
                    '@media screen and (max-width:900px)': {
                        padding: '4px 12px',
                    },
                    '&.Mui-disabled': {
                        background: '#7d7a7f',
                        color: '#FFF'
                    }
                }
            },
            variants: [
                // {
                //     props: { variant: 'light' },
                //     style: {
                //         textTransform: 'none',
                //         border: `1px solid transparent`,
                //         backgroundColor: 'rgba(255,255,255,1)',
                //         '&:hover': {
                //             backgroundColor: 'rgba(255,255,255,0.5)',
                //         },
                //         '&.Mui-disabled': {
                //             backgroundColor: 'rgba(190, 190, 190, 0.2)',
                //             color: '#3b3b3b'
                //         }
                //     },
                // },
                {
                    props: { variant: 'contained' },
                    style: {
                        color: '#323232',
                        backgroundColor: '#FFF',
                        fontWeight: 600,
                        '&:hover': {
                            // backgroundColor: '#323232',
                            color: '#FFF'

                        }
                    },
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        color: '#FFF',
                        borderColor: '#616161',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            borderColor: '#FFF'
                        }
                    },
                },

            ],


        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: 'true'
            }
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    color: '#b7b3b9',
                    '&.Mui-checked': {
                        color: '#b7b3b9',
                    }
                }
            }
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    color: '#b7b3b9',
                    '&.Mui-checked': {
                        color: '#b7b3b9',
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '& .MuiSelect-select': {    //custom multi select
                        padding: '8px 12px',
                    },
                    '& input': {
                        padding: '8px 12px',
                        fontSize: '1rem',
                        '::placeholder': {
                            color: '#7F7F7F',
                            opacity: 0.75,
                        },
                        // color:'#fff'
                    },
                    '& fieldset': {
                        // borderColor: '#E1E1E0',
                        // borderWidth: '1px',
                        borderRadius: '8px'
                    },
                    '&.Mui-disabled': {
                        background: '#717171',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled fieldset': {
                        borderWidth: '1px',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled  .MuiInputAdornment-root': {
                        display: 'none'
                    },
                    '&.Mui-disabled .MuiSelect-icon': {
                        display: 'none'
                    },
                    // '&.MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline ': {
                    //     borderColor: '#A77BCA',
                    //     borderWidth: '1px',
                    // },
                    // '&.Mui-focused fieldset': {
                    //     border: '#FFF !important',
                    //     boxShadow: '0 0 0 0 #E5D7EF',
                    //     borderWidth: '1px',
                    // },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#FFF !important',
                        borderWidth: '1px !important',
                        borderRadius: '8px'
                    }
                    // '&.Mui-error fieldset': {
                    //     borderColor: '#d32f2f',
                    //     borderWidth: '1px',
                    // },

                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    '&.MuiTabs-root': {
                        '& .MuiButtonBase-root': {
                            fontSize: '1rem',
                            fontWeight: 400,
                            textTransform: 'capitalize',
                            '&.Mui-selected': {
                                fontWeight: 400,
                                color: '#d4d4d4'
                            }
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#d4d4d4',
                            height: '1px'
                        }
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    // boxShadow: 'none'
                    boxShadow: '0px 4px 20px 0px #E7DEEE33',
                    borderRadius: '10px',
                    // backgroundColor: '#FFF',
                    '&.MuiPaper-outlined': {
                        borderColor: '#EFEEF0'
                    },
                    '&.MuiPopover-paper': {
                        boxShadow: '0px 4px 20px 0px #0000001F',
                        backgroundImage: 'none'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    height: 24,
                    lineHeight: 'normal'
                }
            }
        }, MuiPickersPopper: {
            styleOverrides: {
                root: {
                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                    zIndex: 9999
                }
            }
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    // backgroundColor:'red',      
                    '& .MuiPaper-root': {
                        backgroundImage: 'none',
                    },
                    '&.MuiAutocomplete-popper .MuiPaper-root': {
                        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                        borderRadius: '4px',
                        // backgroundColor:'red'
                    },
                    '&.zIndex-1400': {
                        zIndex: 1700
                    }

                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    zIndex: 1700
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 1700
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    zIndex: 1600
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    '&.Mui-active': {
                        color: '#fff !important'
                    },
                    '&.Mui-active .MuiStepIcon-text': {
                        fill: '#000 !important'
                    },
                    '&.Mui-completed': {
                        color: '#fff !important'
                    },
                    '&.Mui-completed .MuiStepIcon-text': {
                        fill: '#000 !important'
                    },
                }
            }
        }

    }
};
export const defaultDarkTheme = createTheme({
    palette: {
        mode: 'dark',                          //Assign Palette for dark Mode here
        primary: {
            main: 'rgba(50, 50, 50, 1)',   //#323232
            hover: '#c4c4c4',
            active: '#474747'
        },
        success: {
            main: '#1B6F14',
            light: '#F2FDE2',
            shade: '#009873',
            dashboard: '#02C791',
        },
        error: {
            main: '#E64744',
            light: '#FDE2E2',
            dashboard: '#EF0107'
        },
        info: {
            main: '#5FD7FF',
            light: '#F4FCFF',
            dashboard: '#4AAADF'
        },
        warning: {
            main: '#F1B417',
            light: '#FFFCF3',
            dashboard: '#F9CC50'
        },
        secondary: {
            main: '#f6f6f6'
        },
        text: {
            primary: '#FFF',    //
            secondary: '#D7D7D7', //dark       
        },
        background: {
            default: "rgba(17, 17, 17, 1)",
            paper: '#323232'
        }
    },
    ...uiSettingsDarkMode
});


